import React from 'react';
import { MessageCircle } from 'lucide-react';
import { mockData } from '../mock';

export const WhatsAppButton = () => {
  const handleWhatsAppClick = () => {
    const message = encodeURIComponent('Hi! I would like to get a quote for cleaning services.');
    window.open(`https://wa.me/${mockData.company.whatsapp}?text=${message}`, '_blank', 'noopener');
  };

  return (
    <button
      onClick={handleWhatsAppClick}
      data-testid="whatsapp-float-button"
      className="fixed bottom-6 right-6 z-50 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-2xl transition-all duration-300 hover:scale-110 group"
      aria-label="Contact via WhatsApp"
    >
      <MessageCircle className="w-7 h-7" />
      <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-gray-900 text-white px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
        Get Free Quote
      </span>
    </button>
  );
};
